// react
import React from "react";

//mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { useContext } from "react";
import Tooltip from "@mui/material/Tooltip";

// context
import { DeviceContext } from "../../../Context/deviceContext/deviceContext";

// styles
import useStyles from "./activationCardStyles";

// Card-Header
const CardHeader = (props) => {
  const classes = useStyles();
  const { deviceData } = useContext(DeviceContext);
  return (
    <Box>
      <Grid container alignItems="center">
        <Grid item xs zeroMinWidth>
          {deviceData.gateway_name.length > 14 ? (
            <Tooltip title={deviceData.gateway_name} placement="bottom">
              <Typography noWrap sx={{ fontSize: 17, fontWeight: "bold" }}>
                {deviceData.gateway_name.slice(0,14)+ "..."}
              </Typography>
            </Tooltip>
          ) : (
            <Typography noWrap sx={{ fontSize: 17, fontWeight: "bold" }}>
              {deviceData.gateway_name}
            </Typography>
          )}
        </Grid>
        <Grid item>
          <Chip
            variant="outlined"
            sx={{ fontSize: "12px", fontFamily: "Poppins, sans-serif" }}
            label={
              deviceData.is_device_active || props.deviceState
                ? "active"
                : "Inactive"
            }
            size="small"
            color={
              deviceData.is_device_active || props.deviceState
                ? "success"
                : "error"
            }
          />
        </Grid>
      </Grid>
      <Divider sx={{ mt: 1 }} />
    </Box>
  );
};

// Card-Content
const CardContent = () => {
  const classes = useStyles();
  const { deviceData } = useContext(DeviceContext);

  return (
    <Box>
      <Box sx={{ mt: 1 }}>
        <Grid container>
          <Grid item xs={3}>
            <span className={classes.dataKey}>EUI</span>
          </Grid>
          <Grid item>
            <span className={classes.dataValue}>: {deviceData.dev_eui}</span>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 1 }}>
        <Grid container>
          <Grid item xs={3}>
            <span className={classes.dataKey}>Type</span>
          </Grid>
          <Grid item>
            <span className={classes.dataValue}>
              : {deviceData.gateway_type}
            </span>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 1 }}>
        <Grid container>
          <Grid item xs={3}>
            <span className={classes.dataKey}>App</span>
          </Grid>
          <Grid item>
            {deviceData.app_name.length > 15 ? (
              <Tooltip title={deviceData.app_name} placement="top">
                <span className={classes.dataValue}>
                  : {deviceData.app_name.slice(0, 15) + " ..."}
                </span>
              </Tooltip>
            ) : (
              <span className={classes.dataValue}>: {deviceData.app_name}</span>
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

// DeviceCard Component
const DeviceCard = (props) => {
  const classes = useStyles();
  const { deviceData } = useContext(DeviceContext);

  return (
    <div>
      <p style={{ fontSize: "17px", fontWeight: 500 }}>
        {deviceData.is_device_active
          ? "Device Health Information"
          : "Device Information"}
      </p>

      <Box sx={{ mt: 1 }}>
        <Card className={classes.root} sx={{ borderRadius: 3, width: "300px" }}>
          <CardHeader deviceState={props.deviceState} />
          <CardContent />
        </Card>
      </Box>
    </div>
  );
};

export default DeviceCard;
